import React, { useState, useEffect } from "react";
import Performances from "@/components/gallery/performances";
import { Shell } from "@/components/ui/shell";
import { useGalleryCtx } from "@/contexts/gallery";
import { Separator } from "../ui/separator";
import Winners from "./winners";
import Carpets from "./carpets";
import ExpandedView from "./expanded/expanded-view";
import { GalleryContentProps } from "./types/common";
import Carpet from "../ui/Carpet";

export default function GalleryMain({ data }: GalleryContentProps) {
  const { currentGalleryItem, currentGalleryItems } = useGalleryCtx();
  const isExpandedView = currentGalleryItem !== null;

  const [scrollTarget, setScrollTarget] = useState<number | null>(null);

  const saveScrollPosition = () => {
    setScrollTarget(window.scrollY);
  };

  useEffect(() => {
    if (!isExpandedView && scrollTarget !== null) {
      window.scrollTo({
        top: scrollTarget,
        behavior: "smooth",
      });
      setScrollTarget(null);
    }
  }, [isExpandedView, scrollTarget]);

  return (
    <div>
      {isExpandedView ? (
        <Carpet type="fade-light-to-dark" className="!pb-10">
          <Shell className="3xl:max-w-[1440px]">
            <div className="py-10 lg:py-32">
              <ExpandedView items={currentGalleryItems} />
            </div>
          </Shell>
          <div className="pointer-events-none absolute -bottom-40 z-10 h-80 w-full bg-gradient-to-b from-transparent via-[#875ea5] to-transparent" />
        </Carpet>
      ) : (
        <div className="pb-16">
          <Carpet type="fade-light" className="">
            <div className="px-4 pt-14 sm:px-6 lg:px-8" onClick={saveScrollPosition}>
              <Shell className="mt-20 lg:mt-32">
                <Performances data={data.performances} />
                <Separator className="bg-secondary/40" />
              </Shell>
            </div>
          </Carpet>

          <Carpet type="fade-dark">
            <div className="px-4 sm:px-6 lg:px-8" onClick={saveScrollPosition}>
              <Shell>
                <Carpets data={data.lavender_carpet} />
                <Separator className="bg-secondary/40" />
              </Shell>
            </div>
          </Carpet>

          <Carpet type="fade-light" className="-mb-[31.875rem] pb-[31.875rem]">
            <div className="px-4 sm:px-6 lg:px-8" onClick={saveScrollPosition}>
              <Shell>
                <Winners data={data.winners_and_honoraries} />
              </Shell>
            </div>
          </Carpet>
        </div>
      )}
    </div>
  );
}
